import Reflux from "reflux";
import Freezer from "freezer-js";
import NewsfeedActions from "../react_actions/newsfeed_actions";
import NewsfeedApiClient from "../modules/newsfeed_api_client";
import { merge, map, find, findIndex, forEach } from "lodash";

export const UpdateFeedPreferences = {
  scopes: {
    everyone: {
      value: "everyone",
      label: "Goodreads community",
    },
    friends: {
      value: "friends",
      label: "All friends and people I follow",
    },
    top_friends_following: {
      value: "top_friends_following",
      label: "Top friends and people I follow",
    },
    top_friends: {
      value: "top_friends",
      label: "Top friends only",
    },
  },
  items: {
    books: {
      value: "books",
      label: "Book updates only",
    },
    reviews: {
      value: "reviews",
      label: "Reviews only",
    },
    all: {
      value: "all",
      label: "Everything",
    },
  },
};

const defaultState = {
  newsfeedUpdates: [],
  currentPage: 1,
  minUpdatedAt: null,
  updatesFeedPreferences: {
    item: "all",
    scope: "friends",
  },
  loadingInProgress: false,
  noAdditionalUpdates: false,
};
const state = new Freezer(defaultState);

const getState = () => state.get();

const resetTo = (data) => {
  NewsfeedApiClient.reset();
  getState().reset(merge({}, defaultState, data));
};

const setPageAndPositionForEachUpdate = (updates) => {
  const page = getState().currentPage;
  map(updates, (update, i) => {
    update.page = page;
    update.position = i+1;
  });
  return updates;
};

const setNoAdditionalUpdates = (minUpdatedAt) => {
  getState().set("noAdditionalUpdates", minUpdatedAt === 0);
};

export default Reflux.createStore({
  listenables: [NewsfeedActions],
  getInitialState: getState,
  getState,
  reset: resetTo,

  initializeWith(data) {
    data.updates.newsfeedUpdates = setPageAndPositionForEachUpdate(data.updates.newsfeedUpdates);
    resetTo(data.updates);
    setNoAdditionalUpdates(data.updates.minUpdatedAt);
    if (data.updates.newsfeedUpdates.length > 0) {
      NewsfeedActions.newsfeedItemsLoaded(data.dependentStoreUpdates);
    }
  },

  loadMoreNewsfeedUpdates(requestParams){
    getState().set("loadingInProgress", true);
    this.trigger(getState());
    const promise = NewsfeedApiClient.loadNewsfeedUpdatesOlderThan(getState().minUpdatedAt,
      { requestParams, updatesAlreadyLoaded: getState().newsfeedUpdates });
    return promise.done((resp) => {
      const data = resp.updates;
      if (data.newsfeedUpdates.length > 0) {
        NewsfeedActions.newsfeedItemsLoaded(resp.dependentStoreUpdates);
        const currentState = getState();
        currentState.set({
          minUpdatedAt: data.minUpdatedAt,
          currentPage: currentState.currentPage + 1,
        })
          .newsfeedUpdates.append(setPageAndPositionForEachUpdate(data.newsfeedUpdates));
      }
      setNoAdditionalUpdates(data.minUpdatedAt);
    })
      .fail(() => {
        setNoAdditionalUpdates(0);
      })
      .always(() => {
        getState().set("loadingInProgress", false);
        this.trigger(getState());
      });
  },

  onLoadMoreUpdates() {
    this.loadMoreNewsfeedUpdates();
  },

  onSetUpdatesFeedPreferences(newPrefs) {
    const existingState = getState();
    const currentPrefs = existingState.updatesFeedPreferences;
    const newValues = merge({}, currentPrefs, newPrefs);
    existingState.set("updatesFeedPreferences", newValues);

    const stateWithUpdatedPrefs = getState();
    this.trigger(stateWithUpdatedPrefs);

    const updatedPreferences = stateWithUpdatedPrefs.updatesFeedPreferences;
    const loadMoreParams = {
      update_scope: updatedPreferences.scope,
      update_item: updatedPreferences.item,
    };

    // Keep updatesFeedPreferences data, but throw everything else out.
    // We'll get the rest from the response.
    resetTo({
      updatesFeedPreferences: stateWithUpdatedPrefs.updatesFeedPreferences,
    });

    this.loadMoreNewsfeedUpdates(loadMoreParams)
      .fail(() => {
        window.alert("There was an error during this action, please try again.");
      });
  },

  onUpdateNativeAdSlot(id, data) {
    const update = find(getState().newsfeedUpdates,
      (update) => update.id === id
    );
    if (update) {
      update.reset(data);
    }
  },

  onHideStory(id) {
    const updateIndex = findIndex(getState().newsfeedUpdates,
      (update) => update.id === id
    );
    const newsfeedUpdates = getState().newsfeedUpdates;
    const newNewsfeedUpdates = newsfeedUpdates.splice(updateIndex, 1);
    getState().set("newsfeedUpdates", newNewsfeedUpdates);
    this.trigger(getState());
  },

  onPreviewBook() {
    const pathParts = window.location.pathname.split("/");
    let trackerName = "";

    // Name of tracker is the URL path minus the last part (no ID)
    forEach(pathParts, (pathPart) => {
      trackerName += pathPart;
    });

    $j.post("/track/track", {
      tid: `preview_button--${  trackerName  }--click`,
    });
  },
});
